<script lang="ts">
  import { isNonEmptyArray } from '#app/lib/boolean_tests'
  import type { SerializedEntity } from '#entities/lib/entities'
  import { i18n } from '#user/lib/i18n'
  import { formatYearClaim } from '../lib/claims_helpers'

  const {
    entity,
  }: {
    entity: SerializedEntity
  } = $props()

  const claims = $derived(entity.claims)
  const birthOrDeathDates = $derived(claims && (isNonEmptyArray(claims['wdt:P569']) || isNonEmptyArray(claims['wdt:P570'])))
</script>

{#if birthOrDeathDates}
  <div class="birth-or-death-dates">
    <span title={i18n('wdt:P569')}>
      {formatYearClaim('wdt:P569', claims)}
    </span>
    -
    <span title={i18n('wdt:P570')}>
      {formatYearClaim('wdt:P570', claims)}
    </span>
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";

  .birth-or-death-dates{
    margin-block-end: 0.3em;
  }
</style>
